'use client';

import { Button } from '@components/Button';
import { Four04 } from '@components/Illustrations';
import { FC } from 'react';
import NullResultsMessage from '../';
import { ButtonContainer, IllustrationWrapper, NullContainer } from '../styles';
import { useTranslations } from 'next-intl';

interface NullResultsSearchListingsProps {
  header: string;
  bodyText: string;
  pageType: string;
}

const NullResultsSearchListings: FC<NullResultsSearchListingsProps> = ({
  header,
  bodyText,
  pageType,
}) => {
  const t = useTranslations();

  return (
    <NullContainer>
      <NullResultsMessage header={header} bodyText={bodyText} />

      <ButtonContainer>
        <Button url={'/'} label={t('Return to homepage')} variant="secondary" arrow={false} />
      </ButtonContainer>

      <IllustrationWrapper>
        <Four04 />
      </IllustrationWrapper>
    </NullContainer>
  );
};

export default NullResultsSearchListings;
